import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ProductEligibility } from './types'

export type EligibilityState = {
  data: ProductEligibility
  fetching: boolean
  hasError: boolean
}

const initialState: EligibilityState = {
  data: {
    depositCrypto: {
      enabled: true,
      id: 'DEPOSIT_CRYPTO'
    },
    depositFiat: {
      enabled: true,
      id: 'DEPOSIT_FIAT'
    },
    kycVerification: {
      enabled: true,
      id: 'KYC_VERIFICATION'
    },
    notifications: [],
    trade: {
      enabled: true,
      id: 'TRADE'
    },
    withdrawCrypto: {
      enabled: true,
      id: 'WITHDRAW_CRYPTO'
    },
    withdrawFiat: {
      enabled: true,
      id: 'WITHDRAW_FIAT'
    }
  },
  fetching: false,
  hasError: false
}

const configSlice = createSlice({
  initialState,
  name: 'eligibility',
  reducers: {
    error(state) {
      state.fetching = false
      state.hasError = true
    },
    fetch(state) {
      state.fetching = true
    },
    setEligibility(state, action: PayloadAction<ProductEligibility>) {
      state.hasError = false
      state.fetching = false
      state.data = action.payload
    },
    startPolling() {},
    stopPolling() {}
  }
})

export const { actions } = configSlice
export default configSlice.reducer
